export class Formatter {

  private readonly fn: (value: any) => any;

  constructor(fn: (value: any) => any) {
    this.fn = fn;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  public format(value: any): any {
    return this.fn(value);
  }
}
